import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";

function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const API = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = await axios.post(
        `${API}/api/login`,
        {
          email: email,
          password: password
        }
      );

      setMessage(response.data.message);

      // ✅ Redirect to Dashboard after successful login
      if (response.data.message === "Login successful") {
        navigate("/dashboard");
      }

    } catch (error) {
      setMessage(error.response?.data?.message || "Server error");
    }

  };

  return (
    <div className="login-main">

      <div className="login-left">
        <div className="login-logo">
          <img
            src="/assets/logo/inypeople_logo.png"
            alt="Inypeople Logo"
            className="logo-image"
          />
        </div>

        <img
          src="/assets/images/login_img.png"
          alt="login illustration"
          className="login-image"
        />
      </div>

      <div className="login-right">

        <div className="login-form-box">

          <h2 className="welcome-title">
            Welcome To Inypeople
          </h2>

          <p className="login-subtitle">
            Login to your Account
          </p>

          <form onSubmit={handleSubmit}>

            <input
              type="text"
              placeholder="User Name"
              value={email}
              onChange={(e)=>setEmail(e.target.value)}
              required
              className="login-input"
            />

            <div className="password-box">

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
                required
                className="login-input"
              />

              <img
                src={showPassword ? "/assets/images/Eye_Open.png" : "/assets/images/Eye_Close.png"}
                alt="toggle password"
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />

            </div>

            <button type="submit" className="login-button">
              Sign In
            </button>

          </form>

          <p className="login-message">{message}</p>

        </div>

      </div>

    </div>
  );
}

export default Login;